var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _path, _rect11, _rect12, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoNotes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 115,
    viewBox: "0 0 126 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.32804,
    y: 0.0000152588,
    width: 9.61539,
    height: 109.312,
    rx: 4.80769,
    fill: "#D9D9D9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 125.5,
    y: 100.679,
    width: 9.61539,
    height: 122.172,
    rx: 4.80769,
    transform: "rotate(90 125.5 100.679)",
    fill: "#D9D9D9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.500015,
    y: 5.6561,
    width: 9.61539,
    height: 109.163,
    rx: 4.80769,
    fill: "#EAECF0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 122.672,
    y: 105.204,
    width: 9.61539,
    height: 122.172,
    rx: 4.80769,
    transform: "rotate(90 122.672 105.204)",
    fill: "#EAECF0"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 122.672,
    y: 114.819,
    width: 9.61539,
    height: 109.312,
    rx: 4.80769,
    transform: "rotate(180 122.672 114.819)",
    fill: "#D9D9D9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 0.499931,
    y: 14.1402,
    width: 9.61539,
    height: 122.172,
    rx: 4.80769,
    transform: "rotate(-90 0.499931 14.1402)",
    fill: "#D9D9D9"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 125.5,
    y: 109.163,
    width: 9.61539,
    height: 109.163,
    rx: 4.80769,
    transform: "rotate(180 125.5 109.163)",
    fill: "#EAECF0"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 3.32811,
    y: 9.61545,
    width: 9.61539,
    height: 122.172,
    rx: 4.80769,
    transform: "rotate(-90 3.32811 9.61545)",
    fill: "#EAECF0"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 36.4665,
    y: 72.1697,
    width: 65.9813,
    height: 12.8523,
    rx: 4,
    transform: "rotate(-42.4791 36.4665 72.1697)",
    fill: "#D9D9D9"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 8.36382,
    height: 12.8523,
    rx: 4,
    transform: "matrix(-0.737524 0.675321 0.675321 0.737524 92.4711 20.5218)",
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.1484 85.7975C32.4211 85.9326 31.8039 85.2586 32.0024 84.546L34.6155 75.165C34.8261 74.4087 35.7862 74.179 36.3163 74.758L43.2776 82.3605C43.8078 82.9395 43.4946 83.8756 42.7228 84.019L33.1484 85.7975Z",
    fill: "#D9D9D9"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 34.2966,
    y: 69.8,
    width: 65.9813,
    height: 12.8523,
    rx: 4,
    transform: "rotate(-42.4791 34.2966 69.8)",
    fill: "#EAECF0"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 8.36382,
    height: 12.8523,
    rx: 4,
    transform: "matrix(-0.737524 0.675321 0.675321 0.737524 90.3006 18.1597)",
    fill: "#EAECF0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9786 83.4278C30.2513 83.5629 29.6341 82.8889 29.8326 82.1763L32.4456 72.7953C32.6563 72.039 33.6163 71.8093 34.1465 72.3883L41.1078 79.9908C41.638 80.5698 41.3248 81.5059 40.5529 81.6493L30.9786 83.4278Z",
    fill: "#EAECF0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoNotes);
export default __webpack_public_path__ + "static/media/no-notes.b089bc83559bf805af59e2c3f3342220.svg";
export { ForwardRef as ReactComponent };